import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Location } from '@angular/common';
import {ActivatedRoute, Router} from "@angular/router";

export interface CardAction {
  name: string;
  icon: string;
  disabled?: boolean;
  callback: () => void;
}

@Component({
  selector: 'app-scotty-card',
  templateUrl: './scotty-card.component.html',
  styleUrls: ['./scotty-card.component.scss']
})
export class ScottyCardComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  canGoBack: boolean;

  @Input()
  backLevels = 1;

  @Input()
  hideDivisor: boolean;

  @Input()
  fullWidth: boolean;

  @Input()
  fullHeight: boolean;

  @Input()
  actions: CardAction[];

  _cardActions: CardAction[];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.reloadCardActions();
  }

  reloadCardActions() {
    this._cardActions = this.actions;
  }

  goBack() {
    if (this.location.getState() == 1) {
      let levels = '';
      for (let i = 0; i < this.backLevels; i++) {
        levels += '../';
      }
      this.router.navigate([levels], { relativeTo: this.route })
    } else {
      this.location.back();
    }
  }

}
